import React from 'react';
import ReactPaginate from 'react-paginate';

const CustomPagination = ({
    pageCount,
    onPageChange,
    currentPage,
    perPage,
    onPerPageChange,
    offset,
    totalCount,
    sliceLength,
    itemLabel = "items"
}) => {
    return (
        <div className="pagination-footer">
            <div className="pagination-info">
                Showing {offset + 1}-{Math.min(offset + perPage, offset + sliceLength)} of {totalCount} {itemLabel}
            </div>
            <div className="d-flex align-items-center mx-3">
                <span className="me-2">Rows per page:</span>
                <select
                    className="form-select form-select-sm"
                    style={{ width: 'auto' }}
                    value={perPage}
                    onChange={onPerPageChange}
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                </select>
            </div>
            <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={onPageChange}
                forcePage={currentPage}
                containerClassName={"pagination mb-0"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
            />
        </div>
    );
};

export default CustomPagination;
